<template>
  <div class="page-content-placeholder" :style="{ maxWidth }">
    <v-img :src="imgSrc" width="160" />
    <div v-if="text" class="caption mt-6" v-html="text" />
    <div v-if="subTitle" class="paragraph-m_h text-secondary mt-2" v-html="subTitle" />
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  imgSrc: string;
  text?: string;
  subTitle?: string;
  maxWidth?: string;
}>();

defineSlots<{
  default?: () => void;
}>();
</script>

<style scoped lang="scss">
.page-content-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;

  box-sizing: content-box;

  max-width: 450px;
  margin: auto;
  padding: 24px;

  text-align: center;

  @include xs {
    padding: 16px;
  }
}
</style>
